import { render, staticRenderFns } from "./indicators.vue?vue&type=template&id=2a4d512d&scoped=true&"
import script from "./indicators.vue?vue&type=script&lang=js&"
export * from "./indicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d512d",
  null
  
)

export default component.exports